import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const UserListModel = types
  .model("UserListModel", {
    users: types.array(
      types.model("UserList", {
        id: types.string,
        name: types.string,
        status: types.string,
        isAdmin: types.boolean,
        startDate: types.maybeNull(types.string),
        endDate: types.maybeNull(types.string),
        email: types.string
      })
    ),
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("FETCHING_USER_LIST");
    },
    set(response) {
      const users = response.data.response;
      applySnapshot(self, {
        users,
      });
    },
  }));

export default UserListModel;